import React from "react";
import {
  SiReact,
  SiTailwindcss,
  SiFirebase,
  SiArduino,
  SiJavascript,
  SiHtml5,
  SiCss3,
  SiCplusplus,
} from "react-icons/si";

const techs = [
  { name: "React", icon: <SiReact className="text-blue-500" /> },
  { name: "Tailwind CSS", icon: <SiTailwindcss className="text-cyan-500" /> },
  { name: "Firebase", icon: <SiFirebase className="text-yellow-500" /> },
  { name: "Arduino", icon: <SiArduino className="text-green-600" /> },
  { name: "JavaScript", icon: <SiJavascript className="text-yellow-400" /> },
  { name: "HTML", icon: <SiHtml5 className="text-orange-600" /> },
  { name: "CSS", icon: <SiCss3 className="text-blue-600" /> },
  { name: "C++", icon: <SiCplusplus className="text-purple-600" /> },
];

function TechStack() {
  return (
    <section
      id="tech"
      className="py-20 bg-gray-100 px-6"
      data-aos="fade-up" // ✅ scroll animation for section
    >
      <div className="max-w-5xl mx-auto text-center">
        <h2
          className="text-4xl font-bold text-blue-600 mb-10"
          data-aos="zoom-in"
          data-aos-delay="100"
        >
          Tech Stack
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8">
          {techs.map((tech, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center justify-center hover:shadow-xl transition transform hover:-translate-y-1"
              data-aos="flip-up"
              data-aos-delay={index * 100}
            >
              <div className="text-4xl mb-2">{tech.icon}</div>
              <div className="text-sm font-semibold text-gray-700">
                {tech.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TechStack;
